module.exports = __webpack_public_path__ + "TurboTilesLogo.png";